import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { tr } from '../til';

const card = {
  background: '#fff',
  borderRadius: '12px',
  padding: '24px',
  boxShadow: '0 1px 8px rgba(0,0,0,0.06)'
};

const inputStyle = {
  padding: '10px 12px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '14px',
  width: '100%',
  boxSizing: 'border-box'
};

const smallBtn = {
  padding: '6px 12px',
  background: '#eef1f7',
  color: '#1a1a2e',
  border: '1px solid #ddd',
  borderRadius: '8px',
  fontSize: '12px',
  cursor: 'pointer'
};

// Backend'dagi ROYXATLAR bilan bir xil bo'lishi shart.
const ROYXATLAR = {
  turlar: {
    nom: tr("Taqdimnoma turlari"),
    izoh: tr("Har bir tur — tayyor shablon. Xodim ilovada turni tanlaydi, matn shu yerdan tushadi. Matnlarni normativ hujjatdan aynan ko'chirib qo'ying."),
    ustunlar: [['qisqa_nom', tr("Qisqa nomi")], ['nom', tr("To'liq nomi")], ['modda', tr("Modda")]],
    maydonlar: [
      { k: 'kalit', l: tr("Kalit (ilova shu bo'yicha taniydi, o'zgartirmang)"), majburiy: true },
      { k: 'qisqa_nom', l: tr("Qisqa nomi — ilovadagi tugmada ko'rinadi") },
      { k: 'nom', l: tr("To'liq nomi"), majburiy: true },
      { k: 'modda', l: tr("Modda raqami") },
      { k: 'tartib', l: tr("Tartib raqami"), tur: 'number' },
      { k: 'mavzu_matni', l: tr("Mavzu satri — \"T A Q D I M N O M A\" sarlavhasi ustida turadi"), katta: true },
      { k: 'shaxs_matni', l: tr("1-xatboshi — mahkumning shaxsi"), katta: true },
      { k: 'hukm_matni', l: tr("2-xatboshi — hukm"), katta: true },
      { k: 'qabul_matni', l: tr("3-xatboshi — probatsiyaga qabul qilinishi"), katta: true },
      { k: 'qonun_matni', l: tr("Qonun iqtibosi — hujjatdagi ramkali qism"), katta: true },
      { k: 'sorov_matni', l: tr("Oxirgi xatboshi — suddan so'rov"), katta: true }
    ]
  },
  iiblar: {
    nom: tr("Tuman IIB lari"),
    izoh: tr("Hujjat blankidagi o'zgarmas ma'lumotlar: nomi, manzili, telefoni va imzo qo'yadigan boshliq."),
    ustunlar: [['nom', tr("Nomi")], ['telefon', tr("Telefon")], ['boshliq_ismi', tr("Boshlig'i")]],
    maydonlar: [
      { k: 'nom', l: tr("IIB nomi"), majburiy: true },
      { k: 'manzil', l: tr("Manzili — blankda ko'rinadi") },
      { k: 'telefon', l: tr("Telefoni") },
      { k: 'hujjat_seriyasi', l: tr("Hujjat raqami seriyasi (masalan: 56/30)") },
      { k: 'boshliq_unvoni', l: tr("Boshliq unvoni") },
      { k: 'boshliq_ismi', l: tr("Boshliq ismi (qisqartma)") },
      { k: 'tartib', l: tr("Tartib raqami"), tur: 'number' }
    ]
  },
  sudlar: {
    nom: tr("Sudlar"),
    izoh: tr("Taqdimnoma kimga yuboriladi. Hujjatning o'ng yuqori burchagida uch qator bo'lib chiqadi."),
    ustunlar: [['nom', tr("Sud nomi")], ['raisi', tr("Raisi")]],
    maydonlar: [
      { k: 'nom', l: tr("Sud nomi"), majburiy: true },
      { k: 'lavozimi', l: tr("Murojaat satri (masalan: Jinoyat ishlari bo'yicha ... sudi raisi)") },
      { k: 'raisi', l: tr("Raisi (jo'nalish kelishigida: ...ga)") },
      { k: 'tartib', l: tr("Tartib raqami"), tur: 'number' }
    ]
  }
};

const bosh = (royxat) => {
  const f = {};
  ROYXATLAR[royxat].maydonlar.forEach(m => { f[m.k] = ''; });
  return f;
};

const sanaVaqt = (v) => {
  const d = new Date(v);
  return isNaN(d) ? '' : `${d.toLocaleDateString('uz-UZ')} ${d.toTimeString().slice(0, 5)}`;
};

function Taqdimnoma() {
  const [tab, setTab] = useState('turlar');
  const [yozuvlar, setYozuvlar] = useState([]);
  const [qaydlar, setQaydlar] = useState([]);
  const [orinlar, setOrinlar] = useState([]);
  const [yuklanmoqda, setYuklanmoqda] = useState(true);

  const [tahrir, setTahrir] = useState(null);   // {yangi:true|false, ...maydonlar}
  const [xato, setXato] = useState('');
  const [muvaffaqiyat, setMuvaffaqiyat] = useState('');

  const token = localStorage.getItem('token');
  const jadval = ROYXATLAR[tab];

  const yukla = useCallback(async () => {
    setYuklanmoqda(true);
    try {
      if (tab === 'qaydlar') {
        const res = await axios.get(`${API}/taqdimnoma/qaydlar`, { headers: { authorization: token } });
        setQaydlar(res.data);
      } else {
        const res = await axios.get(`${API}/taqdimnoma/${tab}`, { headers: { authorization: token } });
        setYozuvlar(res.data);
      }
    } catch (err) {
      setXato(err.response?.data?.error || tr("Ro'yxatni ochib bo'lmadi."));
    } finally {
      setYuklanmoqda(false);
    }
  }, [tab, token]);

  useEffect(() => { yukla(); }, [yukla]);

  // O'rin egallovchilar ro'yxati — shablon tahrirlashda yordam sifatida.
  useEffect(() => {
    axios.get(`${API}/taqdimnoma/malumotnomalar`, { headers: { authorization: token } })
      .then(res => setOrinlar(res.data.orin_egallovchilar || []))
      .catch(() => setOrinlar([]));
  }, [token]);

  const saqla = async () => {
    setXato(''); setMuvaffaqiyat('');
    const yetishmayotgan = jadval.maydonlar.find(m => m.majburiy && !String(tahrir[m.k] || '').trim());
    if (yetishmayotgan) { setXato(tr("\"{l}\" to'ldirilishi shart", { l: yetishmayotgan.l })); return; }

    try {
      if (tahrir.yangi) {
        await axios.post(`${API}/taqdimnoma/${tab}`, tahrir, { headers: { authorization: token } });
        setMuvaffaqiyat(tr("Qo'shildi."));
      } else {
        await axios.put(`${API}/taqdimnoma/${tab}/${tahrir.id}`, tahrir, { headers: { authorization: token } });
        setMuvaffaqiyat(tr("Saqlandi."));
      }
      setTahrir(null);
      yukla();
    } catch (err) {
      setXato(err.response?.data?.error || tr("Saqlanmadi."));
    }
  };

  const ochir = async (yozuv) => {
    setXato(''); setMuvaffaqiyat('');
    if (!window.confirm(tr("\"{nom}\" ro'yxatdan olib tashlansinmi?", { nom: yozuv.nom }))) return;
    try {
      await axios.delete(`${API}/taqdimnoma/${tab}/${yozuv.id}`, { headers: { authorization: token } });
      setMuvaffaqiyat(tr("O'chirildi."));
      yukla();
    } catch (err) {
      setXato(err.response?.data?.error || tr("O'chirib bo'lmadi."));
    }
  };

  const tabStyle = (active) => ({
    padding: '8px 18px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    background: active ? '#1a1a2e' : '#fff',
    color: active ? '#fff' : '#666',
    fontSize: '14px',
    cursor: 'pointer'
  });

  // Shablon to'ldirilmagan turlarni ko'rsatish uchun
  const boshShablon = (y) => tab === 'turlar' && !y.qonun_matni && !y.shaxs_matni;

  return (
    <div>
      <h2 style={{ marginBottom: '6px', fontSize: '22px' }}>{tr("Taqdimnoma shablonlari")}</h2>
      <p style={{ marginTop: 0, marginBottom: '20px', color: '#888', fontSize: '13px' }}>
        {tr("Xodim ilovada taqdimnoma to'ldirganda turni, IIB va sudni shu ro'yxatlardan tanlaydi, matn esa shu yerdagi shablondan tushadi.")} <b>{tr("Mahkum ma'lumoti serverda saqlanmaydi")}</b> — {tr("xodim uni har safar qo'lda yozadi.")}
      </p>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
        {Object.entries(ROYXATLAR).map(([k, v]) => (
          <button key={k} onClick={() => { setTab(k); setXato(''); setMuvaffaqiyat(''); }} style={tabStyle(tab === k)}>
            {v.nom}
          </button>
        ))}
        <button onClick={() => { setTab('qaydlar'); setXato(''); }} style={tabStyle(tab === 'qaydlar')}>
          {tr("Qaydlar jurnali")}
        </button>
      </div>

      {xato && (
        <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '14px' }}>
          {xato}
        </div>
      )}
      {muvaffaqiyat && (
        <div style={{ background: '#e9f9ed', color: '#2d8a2d', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginBottom: '14px' }}>
          {muvaffaqiyat}
        </div>
      )}

      {tab === 'qaydlar' ? (
        <div style={card}>
          <h3 style={{ marginTop: 0, marginBottom: '6px', fontSize: '16px' }}>{tr("Chiqarilgan taqdimnomalar")}</h3>
          <p style={{ marginTop: 0, marginBottom: '16px', color: '#999', fontSize: '12px' }}>
            {tr("Mahkumning ismi va boshqa ma'lumoti bu yerda yo'q — faqat kim, qachon va qaysi tur bo'yicha chiqargani.")}
          </p>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', minWidth: '640px' }}>
              <thead>
                <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                  {[tr("Sana"), tr("Xodim"), tr("Turi"), tr("Raqami"), tr("Sud")].map(h => (
                    <th key={h} style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {qaydlar.map(q => (
                  <tr key={q.id} style={{ borderBottom: '1px solid #f9f9f9' }}>
                    <td style={{ padding: '10px 8px', color: '#666' }}>{sanaVaqt(q.created_at)}</td>
                    <td style={{ padding: '10px 8px', fontWeight: '500' }}>{q.user_nomi || '—'}</td>
                    <td style={{ padding: '10px 8px', color: '#666' }}>{q.tur_nomi}</td>
                    <td style={{ padding: '10px 8px', color: '#666' }}>{q.hujjat_raqami || '—'}</td>
                    <td style={{ padding: '10px 8px', color: '#666' }}>{q.sud_nomi || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {!yuklanmoqda && qaydlar.length === 0 && (
            <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', margin: '20px 0 0' }}>
              {tr("Hali taqdimnoma chiqarilmagan.")}
            </p>
          )}
        </div>
      ) : (
        <div style={card}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
            <p style={{ margin: 0, color: '#888', fontSize: '13px', flex: 1, minWidth: '260px' }}>
              {jadval.izoh}
            </p>
            {/* Turlar ro'yxati oldindan belgilangan — yangisini qo'shish odatda kerak emas */}
            <button
              onClick={() => { setTahrir({ ...bosh(tab), yangi: true }); setXato(''); }}
              style={{
                padding: '10px 20px', background: '#1a1a2e', color: '#fff',
                border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', whiteSpace: 'nowrap'
              }}
            >
              + {tr("Qo'shish")}
            </button>
          </div>

          {yuklanmoqda && <p style={{ color: '#999', fontSize: '14px' }}>{tr("Yuklanmoqda...")}</p>}

          {!yuklanmoqda && (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px', minWidth: '600px' }}>
                <thead>
                  <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                    {jadval.ustunlar.map(([, l]) => (
                      <th key={l} style={{ textAlign: 'left', padding: '10px 8px', color: '#888', fontWeight: '500' }}>{l}</th>
                    ))}
                    <th style={{ textAlign: 'right', padding: '10px 8px' }}></th>
                  </tr>
                </thead>
                <tbody>
                  {yozuvlar.map(y => (
                    <tr key={y.id} style={{ borderBottom: '1px solid #f9f9f9' }}>
                      {jadval.ustunlar.map(([k], i) => (
                        <td key={k} style={{ padding: '10px 8px', color: i === 0 ? '#1a1a2e' : '#666', fontWeight: i === 0 ? '500' : '400' }}>
                          {y[k] || '—'}
                          {i === 0 && boshShablon(y) && (
                            <div style={{ color: '#c47f17', fontSize: '12px', marginTop: '2px' }}>
                              ⚠ {tr("Matni to'ldirilmagan — ilovada bo'sh hujjat chiqadi")}
                            </div>
                          )}
                        </td>
                      ))}
                      <td style={{ padding: '10px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                        <button
                          onClick={() => {
                            const f = { ...bosh(tab), yangi: false, id: y.id };
                            jadval.maydonlar.forEach(m => { f[m.k] = y[m.k] ?? ''; });
                            setTahrir(f); setXato('');
                          }}
                          style={{ ...smallBtn, marginRight: '6px' }}
                        >
                          {tr("Tahrirlash")}
                        </button>
                        <button onClick={() => ochir(y)} style={{ ...smallBtn, color: '#c93636' }}>
                          {tr("O'chirish")}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {yozuvlar.length === 0 && (
                <p style={{ color: '#999', fontSize: '14px', textAlign: 'center', margin: '20px 0 0' }}>
                  {tr("Ro'yxat bo'sh. Ilovada xodim tanlay olishi uchun kamida bitta yozuv kerak.")}
                </p>
              )}
            </div>
          )}
        </div>
      )}

      {tahrir && (
        <div
          onClick={() => setTahrir(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', zIndex: 100
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '12px', padding: '24px',
              width: '100%', maxWidth: '760px', maxHeight: '90vh', overflowY: 'auto'
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '18px' }}>
              {tahrir.yangi ? tr("Yangi — {nom}", { nom: jadval.nom }) : tr("Tahrirlash")}
            </h3>

            {tab === 'turlar' && orinlar.length > 0 && (
              <div style={{ background: '#f6f8fb', borderRadius: '8px', padding: '12px', marginBottom: '16px' }}>
                <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
                  {tr("Matn ichiga shu belgilarni qo'ying — ilova ularni xodim kiritgan qiymat bilan almashtiradi:")}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                  {orinlar.map(o => (
                    <span key={o.kalit} title={o.izoh} style={{
                      background: '#fff', border: '1px solid #dde3ec', color: '#4f8ef7',
                      padding: '2px 8px', borderRadius: '6px', fontSize: '12px', fontFamily: 'monospace'
                    }}>
                      {o.kalit}
                    </span>
                  ))}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              {jadval.maydonlar.map(m => (
                <div key={m.k}>
                  <label style={{ display: 'block', fontSize: '12px', color: '#888', marginBottom: '5px' }}>
                    {m.l}{m.majburiy && ' *'}
                  </label>
                  {m.katta ? (
                    <textarea
                      rows={4}
                      value={tahrir[m.k] || ''}
                      onChange={e => setTahrir({ ...tahrir, [m.k]: e.target.value })}
                      style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit', lineHeight: '1.5' }}
                    />
                  ) : (
                    <input
                      type={m.tur || 'text'}
                      value={tahrir[m.k] || ''}
                      onChange={e => setTahrir({ ...tahrir, [m.k]: e.target.value })}
                      style={inputStyle}
                    />
                  )}
                </div>
              ))}
            </div>

            {xato && (
              <div style={{ background: '#ffeaea', color: '#c93636', padding: '10px 12px', borderRadius: '8px', fontSize: '13px', marginTop: '14px' }}>
                {xato}
              </div>
            )}

            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', marginTop: '18px' }}>
              <button onClick={() => setTahrir(null)} style={{ ...smallBtn, padding: '10px 20px', fontSize: '14px' }}>
                {tr("Bekor qilish")}
              </button>
              <button
                onClick={saqla}
                style={{ padding: '10px 24px', background: '#1a1a2e', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}
              >
                {tr("Saqlash")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Taqdimnoma;
